import { api } from "../lib/api";

export const getInstalledCityMap = () =>
  api
    .get("/gmao/map/installed-cities")
    .then((response) => response.data);
